// REACT & Libraries
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import DataTable from "react-data-table-component";
import FilterComponent from "../../Common/FilterComponent";

// Table
import { BarangayTableColumn } from "../../../../Data/DataTables/Barangay";

// Types
import { ViewBarangay } from "../../../../Types/MasterData/Barangay";

// Services
import {
  VIEW_BARANGAY_QUERY_KEY,
  barangayService,
} from "../../../../Services/barangayService";

const BarangayTable = () => {
  const [filterText, setFilterText] = useState("");
  const { data: dataResponse, isLoading } = useQuery({
    queryKey: VIEW_BARANGAY_QUERY_KEY,
    queryFn: barangayService.getAllBarangay,
  });

  const filteredItems: ViewBarangay[] =
    dataResponse?.filter((item: ViewBarangay) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
    ) ?? [];

  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  return (
    <>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={BarangayTableColumn}
          striped={true}
          pagination
          progressPending={isLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default BarangayTable;
